import { ValidationModel, ValidationType } from "@/services/validation/types";

export const powerPlansValidators = {
    name: {
        rules: [
            { type: ValidationType.Required },
            { type: ValidationType.Min, value: 1 }
        ]
    } as ValidationModel
};
